import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { t } from '../i18n';

export default function EmailVerificationPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');

  const verifyEmail = async () => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing');
      return;
    }

    setStatus('verifying');

    try {
      const response = await fetch(`/api/auth/verify-email?token=${token}`);
      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(t('verifiedOK'));
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setStatus('error');
        setMessage(data.error || t('verificationFailed'));
      }
    } catch (err) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #fafdf5 60%, #dcfce7 100%)'
    }}>
      <div className="card" style={{ padding: 40, textAlign: 'center', maxWidth: 400 }}>
        {status === 'pending' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 20 }}>📧</div>
            <h2 style={{ fontSize: 24, marginBottom: 16 }}>{t('confirmEmail')}</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
              {t('verifyWait')}
            </p>
            <button
              onClick={verifyEmail}
              className="btn btn-primary"
              style={{ padding: '12px 24px' }}
            >
              {t('verifyEmailBtn')}
            </button>
          </>
        )}

        {status === 'verifying' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 20 }}>📧</div>
            <h2 style={{ fontSize: 24, marginBottom: 16 }}>{t('verifyingEmail')}</h2>
            <p style={{ color: 'var(--text-muted)' }}>
              {t('verifyWait')}
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 20 }}>✅</div>
            <h2 style={{ fontSize: 24, marginBottom: 16 }}>Email verified!</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
              {message}
            </p>
            <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
              {t('redirectLogin')}
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 20 }}>❌</div>
            <h2 style={{ fontSize: 24, marginBottom: 16 }}>{t('verificationFailed')}</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
              {message}
            </p>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary"
              style={{ padding: '12px 24px' }}
            >
              {t('goToLogin')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
